import React from "react";
import { observer } from "mobx-react-lite";
import NavHeader from "../shared/components/NavHeader";
import EventButton, {
  EventButtonVariant,
} from "../shared/components/EventButton";
import ScheduleStore from "./store/scheduleStore";

interface SchedulePageProps {
  onBack: () => void;
}

const SchedulePageComponent: React.FC<SchedulePageProps> = ({ onBack }) => {
  const handleScheduleSetup = async () => {
    ScheduleStore.scheduleSetups();
    onBack();
  };

  return (
    <div className="min-h-screen bg-black text-white relative">
      <div className="relative z-10">
        <NavHeader onBack={onBack} />

        <div className="max-w-md mx-auto px-6 py-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-medium text-white mb-4">
              Schedule the date and time to send setups
            </h1>
          </div>

          <div className="space-y-6 mb-12">
            <div className="relative">
              <div className="bg-white/90 rounded-xl p-4 flex items-center h-12">
                <span className="mr-3">🗓</span>
                <label
                  htmlFor="schedule-date"
                  className="text-black text-lg font-medium cursor-pointer"
                >
                  {ScheduleStore.selectedDate
                    ? ScheduleStore.formattedDate
                    : "Friday, December 10"}
                </label>
              </div>
              <input
                id="schedule-date"
                type="date"
                value={ScheduleStore.selectedDate}
                onChange={(e) => ScheduleStore.setSelectedDate(e.target.value)}
                className="sr-only"
                min={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="relative">
              <div className="bg-white/90 rounded-xl p-4 flex items-center h-12">
                <span className="mr-3">🕒</span>
                <label htmlFor="schedule-time" className="sr-only">
                  Select time
                </label>
                <input
                  id="schedule-time"
                  type="time"
                  value={ScheduleStore.selectedTime}
                  onChange={(e) =>
                    ScheduleStore.setSelectedTime(e.target.value)
                  }
                  className="bg-transparent text-black text-lg font-medium border-none outline-none"
                />
              </div>
            </div>
          </div>

          {ScheduleStore.isValid && (
            <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 w-full max-w-md px-6">
              <EventButton
                onClick={handleScheduleSetup}
                variant={EventButtonVariant.PRIMARY_WHITE}
                className="w-full text-lg py-4"
                icon="⏱"
                disabled={!ScheduleStore.isValid || ScheduleStore.isLoading}
              >
                {ScheduleStore.isLoading ? "Scheduling..." : "Schedule setup"}
              </EventButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SchedulePage = observer(SchedulePageComponent);

export default SchedulePage;
